import CTABanner from "@/components/CTABanner";
import Footer from "@/components/Footer";

const SiteEnd = () => (
  <div
    data-testid="site-end-section"
    className="relative z-10 mt-10 overflow-hidden rounded-t-[56px]"
    style={{ background: "rgba(255,255,255,0.82)" }}
  >
    <div
      aria-hidden="true"
      className="wave-drift-mask pointer-events-none absolute bottom-[-100px] left-1/2 w-[150vw] -translate-x-1/2 select-none sm:bottom-[-280px] sm:w-[125vw]"
    >
      <div className="wave-drift-track">
        <img src="/assets/waves.png" alt="" className="w-[150vw] max-w-none shrink-0 sm:w-[125vw]" />
        <img src="/assets/waves.png" alt="" className="w-[150vw] max-w-none shrink-0 sm:w-[125vw]" />
      </div>
    </div>
    <div
      className="absolute inset-x-0 bottom-0 h-64 pointer-events-none"
      style={{ background: "radial-gradient(70% 80% at 50% 100%, rgba(17,17,17,0.05) 0%, transparent 70%)" }}
      aria-hidden="true"
    />
    <div className="relative flex flex-col gap-12 px-6 pt-6 pb-8">
      <CTABanner />
      <Footer />
    </div>
  </div>
);

export default SiteEnd;
